import { render, staticRenderFns } from "./AddNewSupplierForm.vue?vue&type=template&id=6e498dec&"
import script from "./AddNewSupplierForm.vue?vue&type=script&lang=js&"
export * from "./AddNewSupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports